export default {
    breakpoints: {
        xl: "screen and (max-width: 75em)", // 1200px/16 = 75em
        lg: "screen and (max-width: 68.75em)", // 1100px screen
        md: "screen and (max-width: 56.25em)", // 900px screen
        sm: "screen and (max-width: 53.125em)", // 850px screen
        xs: "screen and (max-width: 35em)", // 560px screen
        xxs: "screen and (max-width: 26.875em)", // 430px screen
    },
};
